import { useState } from "react";
import { type FieldErrors } from "react-hook-form";
import { css } from "../../../styled-system/css";
import { Button } from "../../components/core/basic/Button";
import { TextField } from "../../components/fields/base/TextField";
import { Flex } from "../../../styled-system/jsx";
import { useTranslation } from "react-i18next";

interface MFARecoveryFormProps {
  onSuccess: (recoveryCode: string) => void;
  showLoginForm: () => void;
  isPending: boolean;
  parentErrors?: FieldErrors;
}

const MFARecoveryForm = ({ onSuccess, showLoginForm, parentErrors, isPending }: MFARecoveryFormProps) => {
  const [recoveryCode, setRecoveryCode] = useState("");
  const { t } = useTranslation("auth");

  const error = parentErrors?.root?.message;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSuccess(recoveryCode);
      }}
    >
      <TextField
        label={t(($) => $.auth.recovery["Recovery Code"])}
        type={"text"}
        onChange={(value) => setRecoveryCode(value)}
        errorMessage={error}
      />
      <Button
        isDisabled={!recoveryCode}
        isPending={isPending}
        className={css({ width: "100%", marginTop: "large" })}
        type="submit"
      >
        {t(($) => $.auth.recovery.Verify)}
      </Button>
      <hr className={css({ width: "100%", marginY: "medium" })} />
      <Flex justifyContent={"center"} marginTop={""}>
        <Button variant={"link"} onClick={showLoginForm}>
          {t(($) => $.auth.recovery["Sign In Instead"])}
        </Button>
      </Flex>
    </form>
  );
};

export default MFARecoveryForm;
